var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('UserInfo',{attrs:{"user":_vm.user,"allowMethodCreation":false,"showEditLink":_vm.showEditLink}}),_c('CardsListUser',{attrs:{"title":'Методы',"userId":_vm.user.id,"showFraza":false}}),_c('CardsList',{attrs:{"title":'Выбранные методы',"cards":_vm.user.favorite_cards}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }